import React from "react";
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import Clients from './client';

import hero1 from '../../images/slider/SAT-Essay.jpg';
import hero4 from '../../images/mainpage/mentorship.jpg';
import photo2 from '../../images/slider/collegue-trip.jpg'
import hero2 from '../../images/slider/s.png';
import hero3 from '../../images/slider/right-img.png';
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css"></link>

const Hero = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />
    };

    return (
        <Slider {...settings} className="hero-slider">
            <section className="wpo-hero-section-1">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col col-xs-6 col-lg-6">
                            <div className="wpo-hero-section-text">
                                <div className="wpo-hero-title-top">
                                    <span>Join Our College Guidance Program</span>
                                </div>
                                <div className="wpo-hero-title">
                                    <h2>College Counseling</h2>
                                </div>
                                <div className="wpo-hero-subtitle">
                                    <p>Guiding High Schoolers to Success with Personalized Mentorship and Academic Planning Join us to empower the next generation with confidence and purpose.</p>
                                </div>
                                <div className="btns">
                                    <Link to="/academic-counseling" className="btn theme-btn-s2">Get Started</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="right-vec">
                                <div className="right-items-wrap">
                                    <div className="right-item">
                                        <div className="r-img">
                                            <img src={hero1} alt=""/>
                                        </div>
                                        <div className="wpo-happy-client">
                                            
                                        </div>
                                    </div>
                                    <div className="right-item">
   
                                        <div className="r-img">
                                            <img src={photo2} alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="wpo-hero-section-1">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col col-xs-6 col-lg-6">
                            <div className="wpo-hero-section-text">
                                <div className="wpo-hero-title-top">
                                    <span>Become a Mentor</span>
                                </div>
                                <div className="wpo-hero-title">
                                    <h2>Mentorship</h2>
                                </div>
                                <div className="wpo-hero-subtitle">
                                    <p>Our Mentorship program fosters growth through weekly meetings, role models, and youth camps, building leaders rooted in values and knowledge.</p>
                                </div>
                                <div className="btns">
                                     <Link to="/mentorship" className="btn theme-btn-s2">Get Started</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="right-vec">
                                <div className="right-items-wrap">
                                    <div className="right-item">
                                        <div className="r-img">
                                            <img src={hero4} alt=""/>
                                        </div>
                                        <div className="wpo-happy-client">
                                            
                                        </div>
                                    </div>
                                    <div className="right-item">
                                        <div className="r-img">
                                            <img src={hero4} alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Slider>
    );
}

const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{
                ...style,
                zIndex: 1,
                background: "#44B4A7",
                right: "50px",
                width: "25px",    
                height: "25px",  
                borderRadius: "50%",  
                display: "flex",  
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                paddingTop: "3px",
                opacity: 0.5,
                transition: "opacity 0.3s ease",
                "&:hover": {
                    opacity: 1
                }
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
            onMouseLeave={(e) => e.currentTarget.style.opacity = 0.5}
            onClick={onClick}
        />
    );
}

const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{
                ...style,
                zIndex: 1,
                background: "#44B4A7",
                left: "10px",
                width: "25px",    
                height: "25px",  
                borderRadius: "50%",  
                display: "flex",  
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                paddingTop: "3px",
                opacity: 0.5,
                transition: "opacity 0.3s ease",
                "&:hover": {
                    opacity: 1
                }
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
            onMouseLeave={(e) => e.currentTarget.style.opacity = 0.5}
            onClick={onClick}
        />
    );
}

export default Hero;
